import ModalComponent from "../../components/modals";
import SimpleTable from "../../components/tables/simpleTable";
import { opportunityHelpConfig } from "./opportunityHelpData";

const ModalComponentOpportunityHelp = ({ openModal, handleClose, helpId }) => {
  const config = opportunityHelpConfig[helpId] || { title: "", columns: [], data: [] };

  return (
    <ModalComponent open={openModal} handleClose={handleClose} title={config.title}>
      <div className="opportunity-help-table-wrap">
        <SimpleTable data={config.data} columns={config.columns} />
      </div>
    </ModalComponent>
  );
};

export default ModalComponentOpportunityHelp;
